import api from '../api';

export interface CompanyPdfData {
  income_3yrs: number;
  taxes_3yrs: number;
  pfot_3yrs: number;
  history_income_year_1?: number | null;
  history_income_year_2?: number | null;
  history_taxes_year_1?: number | null;
  history_taxes_year_2?: number | null;
  history_pfot_year_1?: number | null;
  history_pfot_year_2?: number | null;
}

/** Image-only statements require bounded OCR on the server, beyond the normal API timeout. */
export async function uploadCompanyPdf(file: File): Promise<CompanyPdfData> {
  const body = new FormData();
  body.append('file', file);
  const { data } = await api.post<CompanyPdfData>('/users/me/company/upload-pdf', body, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 90_000,
  });
  return data;
}

export function hasCompleteCompanyHistory(value: CompanyPdfData): boolean {
  return [value.history_income_year_1, value.history_income_year_2,
    value.history_taxes_year_1, value.history_taxes_year_2,
    value.history_pfot_year_1, value.history_pfot_year_2]
    .every(amount => typeof amount === 'number' && Number.isFinite(amount) && amount >= 0);
}

export function companyPdfErrorKey(error: any, prefix: 'calc' | 'fp' | 'profile'): string {
  const code = error?.response?.data?.detail?.code;
  const status = error?.response?.status;
  if (code === 'pdf_processing_timeout' || error?.code === 'ECONNABORTED' || status === 504) return 'pdfImport.timeout';
  if (code === 'pdf_busy' || status === 429) return 'pdfImport.busy';
  if (code === 'pdf_ocr_unavailable' || status === 503) return 'pdfImport.unavailable';
  const part = status === 400 || status === 413 ? '400' : status === 422 ? '422' : 'Default';
  return `${prefix}.${prefix === 'profile' ? 'companyPdfError' : 'pdfError'}${part}`;
}
